declare namespace $ {

	type $mol_image__uri_bog_pazzle_upload_image_1 = $mol_type_enforce<
		ReturnType< $bog_pazzle_upload_image['image_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__title_bog_pazzle_upload_image_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['title'] >
	>
	export class $bog_pazzle_upload_image extends $mol_button_open {
		Icon( ): $mol_icon_image_plus
		Preview( ): $mol_image
		hint( ): string
		image_uri( ): string
		picked( next?: any ): any
		accept( ): string
		multiple( ): boolean
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=image.view.tree.d.ts.map